import AuthGuard from "components/authentication/AuthGuard";
import GuestGuard from "components/authentication/GuestGuard";
import DashboardLayout from "components/Layouts/DashboardLayout";
import LoadingScreen from "components/LoadingScreen";
import { FC, lazy, LazyExoticComponent, Suspense } from "react";
import { Navigate } from "react-router-dom";

const Loadable = (Component: LazyExoticComponent<FC>) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// user profile
// const UserProfile = Loadable(lazy(() => import("./pages/UserProfile")));
// const Register = Loadable(
//   lazy(() => import("./pages/authentication/Register"))
// );

// authentication pages
const Login = Loadable(lazy(() => import("./pages/authentication/Login")));
const ResetPassword = Loadable(
  lazy(() => import("./pages/authentication/ResetPassword")),
);
const ForgetPassword = Loadable(
  lazy(() => import("./pages/authentication/ForgetPassword")),
);
// Dashboard pages
const Dashboard = Loadable(lazy(() => import("./pages/dashboard")));
const ServiceProviders = Loadable(
  lazy(() => import("./pages/ServiceProviders")),
);
const AddNewSP = Loadable(
  lazy(() => import("./pages/ServiceProviders/AddNewSP")),
);
const Beneficiary = Loadable(lazy(() => import("./pages/beneficiary")));
const Services = Loadable(lazy(() => import("./pages/services")));
const AddNewService = Loadable(
  lazy(() => import("./pages/services/AddNewService")),
);
const Cities = Loadable(lazy(() => import("./pages/cities")));
const AddNewCity = Loadable(lazy(() => import("./pages/cities/AddNewCity")));
const Orders = Loadable(lazy(() => import("./pages/orders")));
const Support = Loadable(lazy(() => import("./pages/support")));
const Reports = Loadable(lazy(() => import("./pages/reports")));
const HowItWorks = Loadable(lazy(() => import("./pages/how-it-works")));
const AddNewHowItWork = Loadable(
  lazy(() => import("./pages/how-it-works/AddNew")),
);
const Languages = Loadable(lazy(() => import("./pages/languages")));
const AddNewLanguage = Loadable(lazy(() => import("./pages/languages/AddNew")));

// error
const Error = Loadable(lazy(() => import("./pages/404")));

// routes
const routes = [
  {
    path: "/",
    element: <Navigate to="dashboard" />,
  },
  {
    path: "login",
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    ),
  },
  // {
  //   path: "register",
  //   element: (
  //     <GuestGuard>
  //       <Register />
  //     </GuestGuard>
  //   ),
  // },
  {
    path: "forget-password",
    element: (
      <GuestGuard>
        <ForgetPassword />
      </GuestGuard>
    ),
  },
  {
    path: "reset-password",
    element: (
      <GuestGuard>
        <ResetPassword />
      </GuestGuard>
    ),
  },
  {
    path: "dashboard",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
      {
        path: "service-providers",
        element: <ServiceProviders />,
      },
      {
        path: "service-providers/add",
        element: <AddNewSP />,
      },
      {
        path: "service-providers/edit",
        element: <AddNewSP />,
      },
      {
        path: "beneficiaries",
        element: <Beneficiary />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "services/add",
        element: <AddNewService />,
      },
      {
        path: "services/edit",
        element: <AddNewService />,
      },
      {
        path: "orders",
        element: <Orders />,
      },
      {
        path: "cities",
        element: <Cities />,
      },
      {
        path: "cities/add",
        element: <AddNewCity />,
      },
      {
        path: "cities/edit",
        element: <AddNewCity />,
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "reports",
        element: <Reports />,
      },
      {
        path: "how-it-works",
        element: <HowItWorks />,
      },
      {
        path: "how-it-works/add",
        element: <AddNewHowItWork />,
      },
      {
        path: "how-it-works/edit",
        element: <AddNewHowItWork />,
      },

      {
        path: "languages",
        element: <Languages />,
      },
      {
        path: "languages/add",
        element: <AddNewLanguage />,
      },
      {
        path: "languages/edit",
        element: <AddNewLanguage />,
      },
    ],
  },
  {
    path: "*",
    element: <Error />,
  },
];

export default routes;
